<script>
import * as _ from 'lodash';
import { mapActions, mapState } from 'vuex';

import config from '../config';

export default {
  name: 'CustomerPii',
  computed: {
    ...mapState('customerPii', ['customerPii']),
    ...mapState('genericError', ['ERROR_TYPES']),
  },
  methods: {
    ...mapActions('genericError', ['setErrorType']),
    accountNumberRevealedPii(accountNumberPiiId) {
      const customerAccounts = this.customerPii.accountNumber;
      const accountNumberMapping = _.find(customerAccounts, { piiId: accountNumberPiiId });
      if (!accountNumberMapping) {
        if (config.get().showFallbackTextIfPiiUnavailable) {
          return `pii-unavailable (${accountNumberPiiId})`;
        }
        this.setErrorType(this.ERROR_TYPES.PII_UNAVAILABLE);
        throw new Error(`Didn't find pii value for accountNumberPiiId ${accountNumberPiiId}`);
      }
      return accountNumberMapping.piiValue;
    },
  },
};
</script>
